import * as z from 'zod';
import { wipLineItemId } from '../../types/opaque.mjs';

const blockingReasonCodeSchema = z.enum([
    "missing_statement_date",
    "status_not_reviewable",
    "missing_identity",
    "duplicate_unassigned_identity",
    "duplicate_project_assignment",
    "matched_project_already_assigned",
]);
var BlockingReason;
(function (BlockingReason) {
    BlockingReason.schema = z.object({
        reason: blockingReasonCodeSchema,
        lineItemIds: z.array(wipLineItemId),
    });
})(BlockingReason || (BlockingReason = {}));

export { BlockingReason, blockingReasonCodeSchema };
